import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SessionService } from '../../session-service/session.service';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { Engagement } from '../../models/engagement/engagement.model';
import { EngagementListDto } from '../../models/engagement/engagement-list-dto';
import { API_URL } from '../../../shared/constants/apiurl-constants';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class HomeEditAnEngagementService {
  engagementName: string;
  engagementNumber: string;
  engagementRefresh = new BehaviorSubject(<Engagement | EngagementListDto[]>{});
  homeTableRefresh = new BehaviorSubject({});
  refreshHomeEngagementsTable = this.homeTableRefresh.asObservable();

  constructor(private httpClient: HttpClient,
    public sessionService: SessionService,
    public rightSideDrawerService: RightSideDrawerService,
  ) { }

  refreshHomeTable() {
    this.homeTableRefresh.next(true);
  }

  refreshEngagement(engagement: Engagement | EngagementListDto[]) {
    this.engagementRefresh.next(engagement);
  }

  GetKPMGUsers() {
    return this.sessionService.apiUrlGet(API_URL.CLIENT.GET_ALL_USER);
  }



  GetClientUsers(clientId: number) {
    return this.sessionService.apiUrlGet(
      API_URL.CLIENT.GET_ALL_USER + '?clientId=' + clientId,
    );
  }

  CheckEngagementNumber(engagementNumber: any) {
    return this.sessionService.apiUrlGet(
      API_URL.ENGAGEMENT.CHECKENGAGMENTNUMBER +
      '?engagementNumber=' +
      engagementNumber,
    );
  }

  CheckEngagementName(engagementName: any, clientIdSelected: number) {
    return this.sessionService.apiUrlGet(
      API_URL.ENGAGEMENT.CHECKENGAGEMENTNAME +
      '?engagementName=' +
      engagementName +
      '&clientId=' +
      clientIdSelected,
    );
  }

  UpdateEngagement(engagement: any) {
    return this.sessionService.apiUrlPost(
      API_URL.ENGAGEMENT.EDITENGAGEMENT,
      engagement,
    );
  }

  UpdateStudyAsFavorite(engagementId: number): Observable<boolean> {
    const apiUrl = `${environment.webApiDefaultRoot}Engagement/UpdateStudyFavorite`;
    const params = { params: { engagementId: engagementId } };
    return this.httpClient.post<boolean>(apiUrl, {}, params);
  }
}
